import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetOrdersInTransportInput } from '../../Orders/GetOrdersInTransport/GetOrdersInTransportInput';

export class GetOrderIdListForTransportOrderBaseReportService extends HttpServiceBase {

  constructor(
    http?: any | null
  ) {
    super(http);
  }

  handle = (input: GetOrdersInTransportInput): Promise<Result<number[]> | null> => {
    const promise = this.http.post<Result<number[]>, GetOrdersInTransportInput>(
      `${this.baseUrlSislogApi}/v2/report-orders-in-transport/order-id-list`,
      input);
    return promise;
  }
}